import React from "react";
import Navbar from "../components/Common/Navbar";
import HeroSection from "../components/HomePage/HeroSection";
import QuickDiscovery from "../components/HomePage/QuickDiscovery";
import LifestyleFeatures from "../components/HomePage/LifestyleFeatures";
import LifestyleFeatures2 from "../components/HomePage/LifestyleFeatures2";
import Footer from "../components/Common/Footer";
import Package2Img from "../assets/optimized/packages2.webp";
import Package2MobileImg from "../assets/optimized/packages2-mobile.webp";
import Seo from "../components/HomePage/Seo";
import TrustSection from "../components/HomePage/TrustSection";
import FinalCTA from "../components/HomePage/FinalCTA";

/**
 * The Home layout is designed to be a "full-bleed" container.
 * We remove any horizontal padding or 'items-center' here so that 
 * individual components can decide if they want to touch the edges 
 * (like FinalCTA and Footer) or be centered (like TrustSection).
 */
 const Home = () => {
  return (
    <div className="!w-full min-h-screen flex flex-col bg-[#FAF7F2] overflow-x-hidden !p-0 !m-0">
      <Seo />
      <Navbar />
      
      {/* Hero must be forced to screen width */}
      <div className="w-screen">
        <HeroSection
          image={Package2Img}
          mobileImage={Package2MobileImg}
          title="ADVENTURE"
          tagline="THE JOURNEY DECODED"
        />
      </div>

      <QuickDiscovery />
      <TrustSection />
      <LifestyleFeatures2 />
      <LifestyleFeatures />
      
      {/* The background of these will now touch the edges */}
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Home;